import React, { Component } from 'react';
import ScrollToTopOnMount from '../ScrollToTopOnMount';
import Header from '../Header';
import PolicyMain from './PolicyMain';
import Footer from '../Footer';

class Policy extends Component {
    render() {
        return (
            <div>
                <ScrollToTopOnMount />
                <Header currentPath={this.props.location.pathname} />
                <PolicyMain />
                <Footer />
            </div>
        );
    }
}

export default Policy;